import { useState, useRef, useEffect } from "react";
const useInvokeCallback = (callback) => {
  const [callCount, setCallCount] = useState(0);
  const shouldInvoke = useRef(false);
  useEffect(() => {
    if (callCount > 0 && shouldInvoke.current) {
      shouldInvoke.current = false;
      callback?.();
    }
  }, [callCount, callback]);
  const invokeCallback = () => {
    setCallCount((count) => count + 1);
    shouldInvoke.current = true;
  };
  return invokeCallback;
};
export {
  useInvokeCallback
};
//# sourceMappingURL=use-invoke-callback.js.map
